// Customizable Area Start
import React, { Component } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import { styled } from "@mui/material/styles";
import { Box, Typography } from "@mui/material";
import "swiper/css";
import "swiper/css/pagination";

const CustomSwiper = styled(Swiper)(({ theme }) => ({
  "& .swiper-pagination": {
    position: "absolute",
    bottom: "20px",
    left: "50%",
    transform: "translateX(-50%)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "auto",
    [theme.breakpoints.down("md")]: {
      bottom: "15px",
    },
    [theme.breakpoints.down("sm")]: {
      bottom: "10px",
    },
    [theme.breakpoints.down("xs")]: {
      bottom: "5px",
    },
  },
  "& .swiper-pagination-bullet": {
    width: "8px",
    height: "8px",
    backgroundColor: "#fff",
  },
  "& .swiper-pagination-bullet-active": {
    width: "12px",
    height: "12px",
    backgroundColor: "#fff",
  },
  [theme.breakpoints.down("sm")]: {
    "& .swiper-pagination-bullet": {
      width: "5px",
      height: "5px",
      backgroundColor: "#fff",
    },
    "& .swiper-pagination-bullet-active": {
      width: "7px",
      height: "7px",
    },
  },
}));

const BannerContentWrapper = styled(Box)({
  height: "100%",
  width: "100%",
  display: "flex",
  position: "relative",
  backgroundRepeat: "no-repeat",
  backgroundSize: "cover",
  backgroundPosition: "center",
  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    zIndex: 0,
    backgroundColor: "#290B41C2",
  },
});

const BannerInnerWrapper = styled(Box)({
  position: "relative",
  display: "flex",
  padding: "2.5rem",
  flexDirection: "column",
  alignItems: "center",
  gap: "10px",
  justifyContent: "center",
  zIndex: 1,
  width: "100%",
});

const BigText = styled(Typography)(({ theme }) => ({
  color: "#fff",
  textAlign: "center",
  fontWeight: 600,
  margin: "0 4rem",
  fontSize: "clamp(1.4rem, 5vw, 4.7rem)",
  lineHeight: "clamp(1.8rem, 5vw, 4.8rem)",
  [theme.breakpoints.down("md")]: {
    margin: "0 3rem",
  },
  [theme.breakpoints.down("sm")]: {
    margin: "0 1rem",
  },
}));

const DescriptionText = styled(Typography)(({ theme }) => ({
  color: "#fff",
  textAlign: "center",
  fontWeight: 500,
  fontSize: "clamp(0.9rem, 2vw, 1.125rem)",
  lineHeight: "clamp(1.1rem, 2.5vw, 1.75rem)",
  [theme.breakpoints.down("md")]: {
    margin: "0 2rem",
  },
  [theme.breakpoints.down("sm")]: {
    margin: "0 1rem",
  },
}));

const AUTO_PLAY_CONFIG = {
  delay: 3000,
  disableOnInteraction: false,
  pauseOnMouseEnter: true,
};
const PAGINATION_CONFIG = { clickable: true };

interface IBannerInfo {
  id: string;
  type: string;
  attributes: {
    title: string;
    description: string;
    created_at: string;
    updated_at: string;
    image: string;
  };
}

interface Props {
  bannerSliderData: IBannerInfo[];
}

export class LandingBannerCarousel extends Component<Props> {
  render() {
    const { bannerSliderData } = this.props;
    return (
      <CustomSwiper
        speed={800}
        autoplay={AUTO_PLAY_CONFIG}
        pagination={PAGINATION_CONFIG}
        modules={[Pagination, Autoplay]}
      >
        {bannerSliderData.map((bannerInfo: IBannerInfo) => {
          const {
            id,
            attributes: { image, title, description },
          } = bannerInfo;
          return (
            <SwiperSlide key={id} data-test-id="banner-slide">
              <BannerContentWrapper sx={{ backgroundImage: `url(${image})` }}>
                <BannerInnerWrapper>
                  <BigText sx={{ width: { xs: "100%", lg: "75%" } }}>
                    {title}
                  </BigText>
                  <DescriptionText sx={{ width: { xs: "100%", lg: "75%" } }}>
                    {description}
                  </DescriptionText>
                </BannerInnerWrapper>
              </BannerContentWrapper>
            </SwiperSlide>
          );
        })}
      </CustomSwiper>
    );
  }
}

export default LandingBannerCarousel;
// Customizable Area End
